var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { staticClass: "blue-back", attrs: { xs: "12", md: "6", "no-margin": "" } },
    [
      _c(
        "w-row",
        { attrs: { stretch: "" } },
        [
          !_vm.hideLayoutSelect
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-sale-layout", {
                    staticClass: "mtl",
                    attrs: {
                      id: "",
                      label: _vm.$ct("layout-select"),
                      fancy: "",
                      "sale-type-id": _vm.sale.TypeID,
                      "contact-group-id": _vm.state.getContactGroupID(),
                      "add-default-option": "",
                    },
                    model: {
                      value: _vm.sale.LayoutID,
                      callback: function ($$v) {
                        _vm.$set(_vm.sale, "LayoutID", $$v)
                      },
                      expression: "sale.LayoutID",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-input", {
                attrs: {
                  label: _vm.$ct("comment-print"),
                  value: _vm.toPrintMessage,
                  fancy: "",
                  icon: "edit",
                },
                on: {
                  input: function ($event) {
                    _vm.sale.ToPrintMessage = $event
                  },
                  "icon-click": function ($event) {
                    _vm.editToPrintModal = true
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("comment-not-print"), fancy: "" },
                model: {
                  value: _vm.sale.ToNotPrintMessage,
                  callback: function ($$v) {
                    _vm.$set(_vm.sale, "ToNotPrintMessage", $$v)
                  },
                  expression: "sale.ToNotPrintMessage",
                },
              }),
            ],
            1
          ),
          _vm.state.config &&
          _vm.state.config.AskforBankTransfer &&
          _vm.canQuickBankEdit
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    staticClass: "mr",
                    attrs: {
                      label: _vm.$ct("ask-for-bank-transfer", {
                        type: _vm.saleTypeName,
                      }),
                    },
                    model: {
                      value: _vm.state.saveModalData.quickBankEdit,
                      callback: function ($$v) {
                        _vm.$set(_vm.state.saveModalData, "quickBankEdit", $$v)
                      },
                      expression: "state.saveModalData.quickBankEdit",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.hasCalendarModal
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    staticClass: "mr",
                    attrs: { label: _vm.$ct("create-calendar-event") },
                    model: {
                      value:
                        _vm.state.createCalendarEventState.shouldOpenOnSave,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.state.createCalendarEventState,
                          "shouldOpenOnSave",
                          $$v
                        )
                      },
                      expression:
                        "state.createCalendarEventState.shouldOpenOnSave",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.canSendViaPeppol && !_vm.sale.LastSentViaPeppolDate
            ? _c("w-col", { attrs: { xs: "12" } }, [
                _c(
                  "div",
                  { staticClass: "peppol-checkbox-row" },
                  [
                    _c("w-checkbox", {
                      staticClass: "mr",
                      attrs: { label: _vm.$ct("send-via-peppol") },
                      model: {
                        value: _vm.state.saveModalData.sendViaPeppol,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.state.saveModalData,
                            "sendViaPeppol",
                            $$v
                          )
                        },
                        expression: "state.saveModalData.sendViaPeppol",
                      },
                    }),
                  ],
                  1
                ),
                _vm.state.saveModalData.sendViaPeppol
                  ? _c("div", { staticClass: "peppol-pills" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("peppol-attachments-tooltip"),
                              expression: "$ct('peppol-attachments-tooltip')",
                            },
                          ],
                          staticClass: "peppol-pill",
                          on: {
                            click: function ($event) {
                              _vm.peppolOptionsModal = true
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "paperclip" } }),
                          _vm._v(" " + _vm._s(_vm.peppolFilesCount) + " "),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("peppol-po-tooltip"),
                              expression: "$ct('peppol-po-tooltip')",
                            },
                          ],
                          staticClass: "peppol-pill",
                          on: {
                            click: function ($event) {
                              _vm.peppolOptionsModal = true
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "hashtag" } }),
                          _vm._v(" " + _vm._s(_vm.peppolPoDisplay) + " "),
                        ],
                        1
                      ),
                      _vm.state.saveModalData.peppolOptions.sendCopyToBookkeeper
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("peppol-bookkeeper-tooltip"),
                                  expression:
                                    "$ct('peppol-bookkeeper-tooltip')",
                                },
                              ],
                              staticClass: "peppol-pill",
                              on: {
                                click: function ($event) {
                                  _vm.peppolOptionsModal = true
                                },
                              },
                            },
                            [
                              _c("w-fa", { attrs: { icon: "envelope" } }),
                              _vm._v(
                                " " + _vm._s(_vm.$ct("peppol-bookkeeper")) + " "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasMultiplePeppolEndpoints
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("peppol-endpoint-tooltip"),
                                  expression: "$ct('peppol-endpoint-tooltip')",
                                },
                              ],
                              staticClass: "peppol-pill",
                              on: {
                                click: function ($event) {
                                  _vm.peppolOptionsModal = true
                                },
                              },
                            },
                            [
                              _c("w-fa", { attrs: { icon: "address-card" } }),
                              _vm._v(
                                " " + _vm._s(_vm.peppolEndpointDisplay) + " "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _vm.sale.LastSentViaPeppolDate
            ? _c("w-col", { attrs: { xs: "12" } }, [
                _c("span", { staticClass: "peppol-sent-info" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("already-sent-via-peppol", {
                        date: _vm.formatPeppolDate(
                          _vm.sale.LastSentViaPeppolDate
                        ),
                      })
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.sale.Contact &&
          _vm.userPeppolReady &&
          !_vm.contactPeppolChecking &&
          !_vm.contactPeppolRegistered &&
          _vm.isPeppolSaleType
            ? _c("w-col", { attrs: { xs: "12" } }, [
                _c("span", { staticClass: "peppol-not-available-info" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("peppol-not-available", {
                        name: _vm.sale.Contact.getDisplayName(),
                      })
                    )
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("w-spacer"),
      _c("app-total-box", { attrs: { sale: _vm.sale } }),
      _c(
        "w-row",
        { attrs: { stretch: "" } },
        [
          _c(
            "w-col",
            [
              _c(
                "w-row",
                { staticClass: "buttonbox", attrs: { "no-margin": "" } },
                [
                  _c(
                    "app-sale-edit-finish-button",
                    {
                      attrs: {
                        disabled: _vm.isSaving,
                        icon: "icon-floppy-disk",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("save")) + " ")]
                  ),
                  _c(
                    "app-sale-edit-finish-button",
                    {
                      attrs: {
                        disabled:
                          !_vm.state.getUsedLayoutID(_vm.printContextPrint) ||
                          _vm.isSaving,
                        icon: "icon-printer",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.print()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("print")) + " ")]
                  ),
                  _c(
                    "app-sale-edit-finish-button",
                    {
                      attrs: {
                        disabled:
                          !_vm.state.getUsedLayoutID(_vm.printContextSend) ||
                          _vm.isSaving,
                        icon: "icon-envelope",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.send()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("send")) + " ")]
                  ),
                  _c("app-sale-edit-finish-button", {
                    attrs: {
                      disabled: _vm.isSaving,
                      icon: "icon-ellipsis",
                      light: "",
                      up: "",
                      items: _vm.moreActions,
                      tooltip: _vm.$ct("more-options"),
                    },
                    on: {
                      action: function ($event) {
                        return _vm.onMoreAction($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.salePrintExtraOptionsModalOpen } },
        [
          _vm.salePrintExtraOptionsModalOpen
            ? _c("app-sale-print-extra-options-modal", {
                attrs: { sale: _vm.sale },
                on: {
                  printed: function ($event) {
                    return _vm.onExtraOptionsPrinted()
                  },
                  close: function ($event) {
                    return _vm.onExtraOptionsClosed()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.editToPrintModal } },
        [
          _vm.editToPrintModal
            ? _c("app-text-area-modal", {
                attrs: { title: _vm.$ct("comment-print") },
                on: {
                  close: function ($event) {
                    _vm.editToPrintModal = false
                  },
                },
                model: {
                  value: _vm.sale.ToPrintMessage,
                  callback: function ($$v) {
                    _vm.$set(_vm.sale, "ToPrintMessage", $$v)
                  },
                  expression: "sale.ToPrintMessage",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.peppolOptionsModal } },
        [
          _vm.peppolOptionsModal
            ? _c("app-peppol-send-options-modal", {
                attrs: { endpoints: _vm.peppolEndpoints },
                on: {
                  close: function ($event) {
                    _vm.peppolOptionsModal = false
                  },
                },
                model: {
                  value: _vm.state.saveModalData.peppolOptions,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.saveModalData, "peppolOptions", $$v)
                  },
                  expression: "state.saveModalData.peppolOptions",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }